import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import ToothChart from "../../components/ToothChart";
import TreatmentPlansPanel from "../../components/TreatmentPlansPanel";
import { Tooth } from "@phosphor-icons/react";

export default function MyHistory() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [me, setMe] = useState(null);
  useEffect(() => {
    api.get("/portal/treatments").then((r)=>setItems(r.data));
    api.get("/portal/me").then((r)=>setMe(r.data));
  }, []);

  return (
    <div data-testid="my-history">
      <h1 className="text-3xl sm:text-4xl font-black tracking-tighter" style={{fontFamily:"Manrope, sans-serif"}}>Treatment history</h1>
      <p className="text-sm text-zinc-500 mt-1">A complete record of your dental treatments at Dr Tayyeb&apos;s.</p>

      {me && (
        <div className="mt-8 bg-white border border-zinc-200 rounded-sm p-5">
          <ToothChart patientId={me.id} readOnly />
        </div>
      )}

      {me && (
        <div className="mt-4 bg-white border border-zinc-200 rounded-sm p-5">
          <TreatmentPlansPanel patientId={me.id} readOnly />
        </div>
      )}

      <div className="mt-4 bg-white border border-zinc-200 rounded-sm divide-y divide-zinc-100">
        <div className="px-5 py-4 border-b border-zinc-200">
          <div className="text-[10px] uppercase tracking-[0.25em] font-black text-zinc-700">Treatment log</div>
        </div>
        {items.length === 0 && (
          <div className="p-10 text-center text-sm text-zinc-500">Your treatments will appear here after your first visit.</div>
        )}
        {items.map((t) => (
          <div key={t.id} className="px-5 py-4 flex items-start gap-3" data-testid={`p-tx-${t.id}`}>
            <Tooth size={22} weight="duotone" color="#E60000" className="mt-0.5"/>
            <div className="flex-1 min-w-0">
              <div className="font-bold text-zinc-900">{t.title}</div>
              <div className="text-xs text-zinc-500">
                {t.performed_at?.slice(0,10)} {t.doctor && `Â· ${t.doctor}`} {t.cost ? `Â· â‚¹${t.cost}` : ""}
              </div>
              {t.description && <div className="text-sm text-zinc-700 mt-1">{t.description}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
